export default __webpack_public_path__ + "assets/enterprise-one-two-small.59dd5d8807757fa9cb495f9549357fe2.png";